
import { reactive, defineComponent } from "vue";
// eslint-disable-next-line no-unused-vars
import { SetupContext, EmitsOptions } from "vue";
import { Codebook } from "./Codebook";
import { Statistics } from './Statistics'

export default defineComponent({
  props: {
    selectingType: Boolean,
    codebooksType: String,
  },

  setup(this: void, props: any, ctx: SetupContext<EmitsOptions>) {
    // 按钮文本
    const btnText = {
      encryptText: "> 变身 >",
      encryptHoverText: "> > > >",
      decryptText: "< 还原 <",
      decryptHoverText: "< < < <",
    };
    const btnTextSmall = {
      encryptText: "∨ 变身 ∨",
      encryptHoverText: "∨ ∨ ∨ ∨",
      decryptText: "∧ 还原 ∧",
      decryptHoverText: "∧ ∧ ∧ ∧",
    };

    const state = reactive({
      encryptBtnText: btnText.encryptText,
      decryptBtnText: btnText.decryptText,
      leftContent: "",
      rightContent: "",
      isSmallDevice: false,
    });

    const { encrypt, decrypt, changeCodebookType, spotType } = Codebook();
    const { statistics } = Statistics()

    //解密方法
    function decryptText() {
      const type = spotType(state.rightContent);
      if (type != null) {
        changeCodebookType(type);
        ctx.emit("update:Type", type);
      }
      statistics(1, props.codebooksType)
      state.leftContent = decrypt(state.rightContent);
    }

    //加密方法
    function encryptText() {
      if (state.leftContent.length == 0) return;
      changeCodebookType(props.codebooksType);
      statistics(0, props.codebooksType)
      state.rightContent = encrypt(state.leftContent);
    }

    function widthChange() {
      if (document.body.clientWidth <= 500) {
        state.isSmallDevice = true;
      } else {
        state.isSmallDevice = false;
      }

      state.encryptBtnText = state.isSmallDevice
        ? btnTextSmall.encryptHoverText
        : btnText.encryptHoverText;
      state.encryptBtnText = state.isSmallDevice
        ? btnTextSmall.encryptText
        : btnText.encryptText;

      state.decryptBtnText = state.isSmallDevice
        ? btnTextSmall.decryptHoverText
        : btnText.decryptHoverText;

      state.decryptBtnText = state.isSmallDevice
        ? btnTextSmall.decryptText
        : btnText.decryptText;
    }

    window.onresize = () => {
      widthChange();
    };

    widthChange();
    return {
      btnText,
      btnTextSmall,
      state,
      encryptText,
      decryptText,
    };
  },
});
